import { Pcr } from '../../lib/types/models/pcr/pcr'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcr(id: number) {
  return restApiClient.url(constructApiUrl(API.pcr.get.url, { id })).get<Pcr>()
}
